import React from 'react';
import DoneIcon from '@mui/icons-material/Done';
import WarningIcon from '@mui/icons-material/Warning';
import { Button, Stack } from '@mui/material';

import { highlightUnknownTypePlaneByGuid } from '../../store/actions/layout/genericPlaneActions';
import { getPickingObjectInfo } from '../../store/selectors/pickingSelectors';
import {
  applicationOnPickingPlane,
  clearPickingObject,
  PickingPlaneTargetInfo,
} from '../../store/slices/applicationSlice';
import { layoutSlice } from '../../store/slices/layoutSlice';
import { useAppDispatch, useAppSelector } from '../hooks';

interface PlanePickerFieldProps {
  label: string;
  disabled?: boolean;

  value: string | null;
  target: PickingPlaneTargetInfo;
}

export function PlanePickerField(props: PlanePickerFieldProps) {
  const dispatch = useAppDispatch();

  const pickingObjectInfo = useAppSelector(getPickingObjectInfo);

  const isPicking = pickingObjectInfo?.type === 'pickingPlane';
  const thisControlIsPicking = isPicking && pickingObjectInfo.targetInfo.type === props.target.type;

  return (
    <div>
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <Button
          variant="outlined"
          startIcon={props.value ? <DoneIcon /> : <WarningIcon />}
          disabled={props.disabled || props.value == null || isPicking}
          onPointerEnter={() => {
            if (props.value != null) {
              dispatch(highlightUnknownTypePlaneByGuid(props.value));
            }
          }}
          onPointerLeave={() => {
            dispatch(layoutSlice.actions.highlightedPlanesCleared());
          }}
          onClick={() => {
            dispatch(applicationOnPickingPlane(props.target));
          }}
        >
          {props.label} {props.value ? 'Chosen' : 'Needed'}
        </Button>

        <Button
          variant={thisControlIsPicking ? 'contained' : props.value ? 'text' : 'outlined'}
          disabled={props.disabled || (isPicking && !thisControlIsPicking)}
          onClick={() => {
            if (thisControlIsPicking) {
              dispatch(clearPickingObject());
            } else {
              dispatch(applicationOnPickingPlane(props.target));
            }
          }}
        >
          {thisControlIsPicking ? 'Picking...' : props.value ? 'Pick Again' : 'Pick'}
        </Button>
      </Stack>
    </div>
  );
}
